import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Map } from 'immutable';
import DropDownButton from '../../ui/DropDownButton';
import { OrganizationActions } from '../../../actions/organization';
import { ModalActions } from '../../../actions//modal';

import faBars from '@fortawesome/fontawesome-pro-light/faBars';

@withRouter
export default class ContextMenu extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    organizationId: PropTypes.number,
    userMode: PropTypes.string,
    currentUser: PropTypes.instanceOf(Map),
  };

  countAccounts = () => {
    const { organization } = this.props;
    const count = organization.getIn(['counts', 'accounts'], 0);
    return parseInt(count, 10);
  };

  renameOrganization = () => {
    const { dispatch, organization } = this.props;
    dispatch(
      ModalActions.toggleModal({
        name: 'RenameOrganizationModal',
        options: {
          currentOrganizationId: organization.get('id'),
          organizationName: organization.get('name'),
        },
      }),
    );
  };

  confirmDelete = () => {
    const { dispatch, organization } = this.props;

    // const orgIdToDelete = organization.get('id');
    const name = organization.get('name');

    dispatch(ModalActions.toggleModal({
      name: 'DeleteConfirmationModal',
      options: {
        deleteType: 'organization',
        handleDelete: this.deleteOrganization.bind(this),
        name,
      },
    }));
  }

  deleteOrganization = () => {
    const { dispatch, organization, currentUser } = this.props;
    const organizationId = organization.get('id');
    const userId = currentUser.get('id');
    dispatch(OrganizationActions.deleteOrganization(organizationId, userId));
  };

  render() {
    const { currentUser, organization, router } = this.props;
    const organizationId = organization.get('id');
    // const adminMode = userMode === 'admin';
    const superAdmin = currentUser.get('role_id') === 1;
    const accounts = this.countAccounts();
    // if (!superAdmin) return null;

const deleteItem = (accounts === 0) ?
      <a onClick={this.confirmDelete} className="dropdown-item">
        Delete
      </a>
    : <span className="dropdown-item text-muted">
        Delete <i className="fa fa-exclamation-triangle" aria-hidden="true" />
      </span>

    const renameItem = (
      <a onClick={this.renameOrganization} className="dropdown-item">
        Rename
      </a>
    );

    const link = `/organizations/${organizationId}`;

    return (
      <DropDownButton
        title=""
        icon={faBars}
        mouseLeave
        hideToggle
        isHoverButton
        styleOverrides={{
          background: '#f5f5f5',
        }}
        style={{
          marginTop: 5,
          marginBottom: 5,
          marginRight: 5,
          float: 'right',
          zIndex: 3000,
        }}
      >
        <a onClick={() => router.push(link)} className="dropdown-item">
          View
        </a>
        {superAdmin && deleteItem}
        {superAdmin && renameItem}
      </DropDownButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/contextMenus/organizationContext.js